/** A contract row in Customize mode (E3, spec 2026-09-18 §6): shown, never
 * editable, with the reason. The server refuses the same paths
 * (`overlay_step_field_locked`). */
import { Lock } from 'lucide-react'

export const FORK_SENTENCE = 'Contract. Re-wiring is a fork: take ownership to change it.'

export function LockedRow({ label, value, reason = FORK_SENTENCE }: { label: string; value: string; reason?: string }) {
  return (
    <div className="flex items-start gap-2 rounded-sm border border-border/60 bg-muted/40 p-2 text-xs">
      <Lock aria-label="locked" className="mt-0.5 h-3.5 w-3.5 shrink-0 text-muted-foreground" />
      <div className="min-w-0 flex-1">
        <p className="font-medium text-foreground">{label}</p>
        <p className="text-muted-foreground">{value}</p>
        <p className="mt-1 text-[11px] text-muted-foreground">{reason}</p>
      </div>
    </div>
  )
}
